import { Type } from "@angular/core";
import { ActionService } from "../../../services/action.service";
import { ClosePlanCommand } from "../../../shared/commands/close-plan-command";
import { CreateCommand } from "../../../shared/commands/create-command";
import { DownloadExcelCommand } from "../../../shared/commands/download-excel-command";
import { ConfirmDialogComponent } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";
import { ActionCol } from "../../../shared/table-col-configs/action-col";
import { ActionButtonsComponent } from "../../../shared/table-components/action-buttons/action-buttons.component";
import { CheckboxComponent } from "../../../shared/table-components/checkbox/checkbox.component";
import { DeleteCommand } from "../../records/commands/delete-command";
import { TextCol } from "../../records/models/columns/text-col";
import { TableStructure } from "../../records/models/table-structure";
import { CLOSE_ACTION_PLAN_DIALOG_CONFIG } from "./close-action-plan-dialog-config";
import { DELETE_ACTION_PLAN_DIALOG_CONFIG } from "./delete-action-plan-dialog-config";
import { ActionPlan } from "./models/action-plan";

export const genActionPlanTableConfig = (service: ActionService) => {
  const ACTION_PLAN_TABLE_CONFIG: TableStructure<ActionPlan> = new TableStructure<ActionPlan>(
    [
      new TextCol("outletId", undefined, "actionPlan.outletId"),
      new TextCol("outletName", undefined, "actionPlan.outletName"),
      new TextCol("sectionValue", undefined, "actionPlan.sectionValue",undefined,true),
      new TextCol("title", undefined, "actionPlan.title"),
      new TextCol("status", undefined, "actionPlan.status",undefined,true),
      new TextCol("kpi", false, "actionPlan.kpi", "", true),
      new TextCol("kpiStartValue", undefined, "actionPlan.kpiStartValue"),
      new TextCol("kpiActualValue", undefined, "actionPlan.kpiActualValue"),
      new TextCol("kpiGoalValue", undefined, "actionPlan.kpiGoalValue"),
      new TextCol("dtStart", undefined, "actionPlan.dtStart", "dd/MM/YYYY"),
      new TextCol("dtEnd", undefined, 'actionPlan.dtEnd', "dd/MM/YYYY"),
      new ActionCol<ActionPlan, Type<CheckboxComponent<ActionPlan>>, ActionService>(
        "closeAction",
        false,
        "actionPlan.close",
        [
          new ClosePlanCommand<ActionPlan, ActionService>(
            service,
            ConfirmDialogComponent,
            CLOSE_ACTION_PLAN_DIALOG_CONFIG
          ),
        ],
        CheckboxComponent
      ),
      new ActionCol<ActionPlan, Type<ActionButtonsComponent<ActionPlan>>, ActionService>(
        "deleteAction",
        false,
        "actionPlan.delete",
        [
          new DeleteCommand<ActionPlan, ActionService>(
            service,
            ConfirmDialogComponent,
            DELETE_ACTION_PLAN_DIALOG_CONFIG
          ),
        ],
        ActionButtonsComponent
      ),
    ],
    "clientSide",
    undefined,
    undefined,
    false,
    [
      new DownloadExcelCommand<ActionPlan, ActionService>(service),
      new CreateCommand<ActionPlan, ActionService>(service),
    ]
  );
  return ACTION_PLAN_TABLE_CONFIG;
};
